import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Autocomplete, TextField, List, ListItem,
  IconButton, Typography, CircularProgress
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { getIcon } from './../../../../utils/IconHandler';
import { addProductsToCategoryView } from '../../../../services/ProductService';

const AddProductsToCategoryModal = ({
  open,
  onClose,
  onSaved,
  allProducts,
  locationId,
  subcategoryId,
  onProductAdded
}) => {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);

  // Resetear estado cada vez que se abre el modal
  useEffect(() => {
    if (open) {
      setSelectedProducts([]);
      setInputValue('');
      setLoading(false);
    }
  }, [open]);

  const handleAdd = (event, value) => {
    if (value && !selectedProducts.find(p => p.id === value.id)) {
      setSelectedProducts(prev => [...prev, value]);
    }
    setInputValue('');
  };

  const handleRemove = (id) => {
    setSelectedProducts(prev => prev.filter(p => p.id !== id));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const productIds = selectedProducts.map(p => p.id);
      await addProductsToCategoryView(locationId, subcategoryId, productIds);

      // 🔄 Notificar al padre para actualizar productos visibles
      if (onProductAdded) {
        onProductAdded(productIds);
      }

      onClose();
      onSaved();
    } catch (error) {
      console.error('Error al guardar productos:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Agregar productos</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <Autocomplete
              options={allProducts}
              getOptionLabel={(option) => option.name}
              value={null}
              onChange={handleAdd}
              inputValue={inputValue}
              onInputChange={(e, newInput) => setInputValue(newInput)}
              renderInput={(params) => <TextField {...params} label="Producto" fullWidth />}
            />

            <List>
              {selectedProducts.map((product) => (
                <ListItem
                  key={product.id}
                  secondaryAction={
                    <IconButton edge="end" onClick={() => handleRemove(product.id)}>
                      {getIcon('trash')}
                    </IconButton>
                  }
                >
                  <Typography>{product.name}</Typography>
                </ListItem>
              ))}
            </List>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <LoadingButton onClick={handleSave} loading={loading} variant="contained">
          Guardar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddProductsToCategoryModal;